// homePage.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { AudioProvider, useAudio } from '../contexts/AudioContext';
import './HomePage.css';
import { Container, Box, Typography, Button } from '@mui/material';


export default function HomePage() {
  
  return (
    <div>
    <Container maxWidth="md" style={{ marginTop: '20px' }}>
        <Box sx={{ bgcolor: 'background.paper', padding: '20px', borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom>
            O Nas
          </Typography>
          <Typography variant="body1" paragraph>
            Mosaic Guardians to organizacja, która łączy ludzi w celu ochrony i promowania mądrości oraz wiedzy. Nasza misja to inspirowanie innych do działania na rzecz lepszego świata.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Nasze Cele
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">Ochrona i promocja wiedzy</Typography>
            </li>
            <li>
              <Typography variant="body1">Wspieranie współpracy w złożonym świecie</Typography>
            </li>
            <li>
              <Typography variant="body1">Inspirowanie do działania dla dobra wspólnego</Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom>
            Kontakt
          </Typography>
          <Typography variant="body1" paragraph>
            Aby dowiedzieć się więcej o naszej organizacji, skontaktuj się z nami przez formularz kontaktowy na naszej stronie.
          </Typography>

          <Button variant="contained" color="primary">Skontaktuj się z nami</Button>
        </Box>
      </Container>

      <footer style={{ textAlign: 'center', padding: '10px', backgroundColor: '#333', color: 'white', position: 'fixed', bottom: 0, width: '100%' }}>
        <p>&copy; 2023 Mosaic Guardians. Wszelkie prawa zastrzeżone.</p>
      </footer>
      </div>
  )
  
};

